"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.resetAll = exports.reset = exports.resetuserprofile = exports.userDefaults = exports.editprofiles = exports.screenamountprofiles = exports.languagecodes = exports.culture = exports.settings = exports.usersettings = exports.newMoistureLoad = exports.newPricing = exports.pricingmanager = exports.pricing = exports.newsystem = exports.systemsmanager = exports.newInHelpDeskHeader = exports.favourites = exports.dashboard = exports.alert = exports.system = exports.quickSelect = exports.systemSettings = exports.arrangement = exports.systemArrangement = exports.logout = exports.logintime = exports.loggedinuser = exports.edContinue = exports.edcopyexception = exports.edreload = exports.reportoptions = exports.edsubmitreport = exports.edviewreport = exports.chooseMonths = exports.chooseLabels = exports.labelsmanager = exports.gasHeater = exports.pullDownTime = exports.condenser = exports.steamHeater = exports.electricHeater = exports.calculating = exports.calculateSystems = exports.variant = exports.errors = exports.warnings = exports.preValidation = exports.systemCreated = exports.dhCapacity = void 0;
exports.requestAccessLevel = exports.changelog = exports.calculatingEnergyCase = exports.abort = exports.about = exports.startpage = exports.errorreports = exports.newMoistureLoadCalc = exports.moistureLoadManager = exports.drysize = exports.moistureLoadCalculation = exports.opcMlcImportText = exports.connectSystemTomlc = exports.moistureLoadNo = exports.moistureLoadCreated = exports.moistureLoadName = exports.moistureLoad = exports.translationSearch = exports.tAndCAcceptanceStatus = exports.advancedProductSearch = exports.viewAll = exports.viewEffectiveClaims = exports.usagestatistics = exports.iceDryTool = exports.dataCenterWizard = exports.sycoolTool = exports.nevadaTestSite = exports.fanMotorProTool = exports.fanProTool = exports.coilProTool = exports.calculatePower = exports.calculateAirOut = exports.power = exports.pressure = exports.flow = exports.airOut = exports.airIn = exports.airPowerTool = exports.condensation = exports.air2 = exports.air1 = exports.airMixer = exports.fanChart = exports.density = exports.humidityConversion = exports.dryCap = exports.binPage = exports.generate = exports.psychrometricChart = exports.tools = void 0;
exports.defaultCurrency = exports.browserinformation = exports.unsupportedBrowser = exports.createProfile = exports.newText = exports.save = exports.selected = exports.select = exports.back = exports.assign = exports.cancel = exports.close = exports.del = exports.edit = exports.measureSystem = exports.type = exports.name = exports.elevation = exports.systemsFromAllSystems = exports.systemsFromMySystems = exports.systems = exports.lastChange = exports.showallrecentlychangedsystems = exports.recentsystemsheader = exports.longitude = exports.latitude = exports.load = exports.printData = exports.headerLabel = exports.papersize = exports.fileformat = exports.location = exports.state = exports.country = exports.dateTimeNumberFormat = exports.measuresystem = exports.currency = exports.language = exports.open = exports.confirmation = exports.update = exports.ok = exports.no = exports.yes = exports.confirmresetallsettings = exports.helpmenu = exports.maintenance = exports.instructionVideos = exports.legacyClient = exports.wiki = void 0;
exports.allPricings = exports.allMoistureLoads = exports.myMoistureLoad = exports.myPricings = exports.pages = exports.of = exports.helpAboutSearching = exports.saveAsPrecheckedDefault = exports.clear = exports.to = exports.from = exports.date = exports.enterFileNameHere = exports.noAssignedLabels = exports.showUnassigned = exports.showLess = exports.showAll = exports.changeLog = exports.systemInformation = exports.faq = exports.traningVideos = exports.helpCenter = exports.noRecentSystemsMsg = exports.noFavoritesMsg = exports.createNewSystem = exports.labelName = exports.newLabel = exports.createNewLabel = exports.assignedLabels = exports.allLabels = exports.confirmdelete = exports.confirmdeletelong = exports.transfertouser = exports.createnewrevision = exports.copylatestrevision = exports.editLabels = exports.assignlabels = exports.rename = exports.labels = exports.status = exports.allowedClaims = exports.allowedUsers = exports.subject = exports.value = exports.you = exports.owner = exports.changed = exports.deleteArticleConfirm = exports.deleteArticle = exports.defaultSalesOrganisation = void 0;
exports.unit = exports.quantity = exports.caseshort = exports.pidshort = exports.description = exports.group = exports.salesorg = exports.pricingCurrency = exports.add = exports.articleNo = exports.rowNo = exports.articleGroup = exports.header = exports.article = exports.piece = exports.refresh = exports.requestBuild = exports.couldNotBuild = exports.longRunningTask = exports.buildState = exports.stopCalculations = exports.continueText = exports.confirm = exports.deleteLabelMsg = exports.deleteText = exports.createNew = exports.usingLabelsMsg = exports.usingLabels = exports.systemsPerPage = exports.actions = exports.cannotShowMechanicalSketchStaticMsg = exports.cannotShowMechanicalSketchMsg = exports.exportSketch = exports.systemCompare = exports.projectSelection = exports.summary = exports.exampleTemplate = exports.importText = exports.exportText = exports.moreActions = exports.deletedBy = exports.recoverSystem = exports.createPricingAndAdd = exports.nocomment = exports.comment = exports.editComment = exports.copyTransferOpen = exports.latestRevNeedsToBeLocked = exports.allSystems = exports.mySystems = void 0;
exports.coils = exports.generating = exports.createDocx = exports.createPDF = exports.create = exports.newRow = exports.downloadDotDotDot = exports.upload = exports.rebuild = exports.download = exports.preview = exports.savePricingToCreateReport = exports.pricingReport = exports.pricingNoSystemFound = exports.genesysNo = exports.search = exports.deleteAllRowsConfirm = exports.deleteRowConfirm = exports.deleteRow = exports.deleteAllRows = exports.lockingPricingInfo = exports.includeTotalPrice = exports.includePriceSubtotal = exports.includeTransferPrice = exports.includeListPrice = exports.includePricePerUnit = exports.includeMargin = exports.includeCost = exports.printPreview = exports.lockPricing = exports.totalMarginPercent = exports.totalTransferPrice = exports.totalListPrice = exports.totalPrice = exports.componentSpec = exports.goToProductPage = exports.notes = exports.listPriceSubtotal = exports.transferPriceSubtotal = exports.priceSubtotal = exports.costSubtotal = exports.total = exports.discountPercent = exports.listPricePerUnit = exports.transferPricePerUnit = exports.pricePerUnit = exports.listPriceFactor = exports.transferPriceFactor = exports.priceFactor = exports.costPerUnit = void 0;
exports.na2SsEmpty2 = exports.na2SsEmpty1 = exports.na2SsSize2 = exports.na2SsSize1 = exports.na2SsAirflows = exports.na2SsHumidifier = exports.na2SsCoils = exports.na2SsFilters = exports.pNull = exports.and = exports.or = exports.error = exports.selectLocation = exports.noSizesFoundForVelocity = exports.targetPower = exports.maxVelocity = exports.minVelocity = exports.velocity = exports.faceArea = exports.totalCoolingPower = exports.reactHeaterPower = exports.purge = exports.model = exports.plenum = exports.dehumidifier = exports.serviceCalculationNotLocked = exports.serviceCalculation = exports.sizeSelection = exports.operatingCases = exports.allCalculationsFailed = exports.purgeTypes = exports.noVariantsGenerated = exports.products = exports.calculateMoistureLoad = exports.initialConfiguration = exports.supplyAirFlow = exports.supplyHumidity = exports.finish = exports.nextStep = exports.next = exports.previous = exports.selectSystemSize = exports.selectProductRange = exports.nameAndLabels = exports.moistureloadName = exports.pricingName = exports.moistureCapacity = exports.postCoil = exports.blendCoil = exports.preCoil = void 0;
exports.binCases = exports.binSize = exports.binLocation = exports.binId = exports.selectedSystems = exports.results = exports.inputs = exports.projectIdAlreadyExists = exports.redundant = exports.unitsDefined = exports.numberOfUnits = exports.configurationName = exports.totalMaxPower = exports.suggestedNumberOfUnits = exports.requiredNumberOfUnits = exports.maxPowerPerUnit = exports.unitNominalAirflow = exports.flowPerUnit = exports.powerPerUnit = exports.editAdditionalLabels = exports.noAdditionalLabelsAssigned = exports.projectName = exports.dcEpxSize = exports.dcSuggestedUnits = exports.dcSuggest = exports.dcOutdoorSummer = exports.dcProjectInfo = exports.dcRange = exports.dcProjectInput = exports.dimensions = exports.na2SsEurovent = exports.na2SsBaseFrameHeight = exports.na2SsExternalWidth = exports.na2SsExternalHeight = exports.na2SsBox = exports.na2SsMaxFlow2 = exports.na2SsMaxFlow1 = exports.na2SsMinFlow2 = exports.na2SsMinFlow1 = exports.na2SsHumidifier1 = exports.na2SsCoolCoil1 = exports.na2SsHeatCoil1 = exports.na2SsCarFilter2 = exports.na2SsCarFilter1 = exports.na2SsAbsFilter2 = exports.na2SsAbsFilter1 = exports.na2SsFilter2 = exports.na2SsFilter1 = exports.na2SsNoMax = exports.na2SsMax = void 0;
exports.julyHours = exports.juneHours = exports.mayHours = exports.aprilHours = exports.marchHours = exports.februaryHours = exports.januaryHours = exports.exportBinsWithMonths = exports.mlcExportResults = exports.exportBinsAsStandard = exports.time = exports.targetHumidity = exports.targetTemp = exports.returnHumidity = exports.returnTemp = exports.averageSpecificEnthalpy = exports.averageHumidity = exports.humidity = exports.averageTemp = exports.midPointSpecificEnthalpy = exports.midPointHourly = exports.midPointHumidityRatio = exports.midPointDewPointTemp = exports.midPointWetTemp = exports.midPointTemp = exports.chartXAxis = exports.chartPreset = exports.binViewWithMonths = exports.binViewStandard = exports.bins = exports.month = exports.months = exports.chart = exports.list = exports.viewAs = exports.print = exports.detailedResults = exports.predictedLccCost = exports.predictedAnnualExtra = exports.predictedAnnualCost = exports.predictedAnnualEmission = exports.predictedAnnualConsumption = exports.systemStatusTooLowMsg = exports.energyNotCalculatedShort = exports.energyNotCalculated = exports.noEnergySumResultAvailable = exports.noTcoResultAvailable = exports.noEnergyResultAvailable = exports.energySumSystemStatus = exports.binCasesMissing = void 0;
exports.noPayback = exports.immediatePayback = exports.noDescription = exports.alternative = exports.baseline = exports.baseSystem = exports.baselineSystem = exports.compare = exports.filters = exports.addNew = exports.duplicate = exports.systemActions = exports.systemRevisionActions = exports.airLocations = exports.notesAndDocuments = exports.componentAlternatives = exports.other = exports.enhanceComponent = exports.accessories = exports.systemAccessories = exports.properties = exports.propertyGroup = exports.climatixControlFile = exports.revitBuilder = exports.wiringDiagramBuilder = exports.solidContactBuilder = exports.totalCostOfOwnership = exports.mCompare = exports.energy = exports.adjustPrice = exports.psychrometricsChart = exports.systemDocuments = exports.systemPrintout = exports.systemSize = exports.pidDiagramEContact = exports.pidDiagram = exports.mechanicalSketch = exports.systemDiagram = exports.processingsteps = exports.screens = exports.temperature = exports.binOn = exports.dataType = exports.binPressure = exports.wind = exports.decemberHours = exports.novemberHours = exports.octoberHours = exports.septemberHours = exports.augustHours = void 0;
exports.validateFinal = exports.generateCasings = exports.calculateRatingCases = exports.validateDesign = exports.calculateDesign = exports.validateSelections = exports.CustomPressure = exports.calculate = exports.dhCapacityInfo = exports.sewage = exports.water = exports.humidifier = exports.steamHeatSystem = exports.hotWaterSystem = exports.chilledWaterSystem = exports.gasHeaters = exports.electricity = exports.calculationfailed = exports.revisionCompletedMsg = exports.copyOfSystemCompletedMsg = exports.openInCurrentTab = exports.invalidBinMessage = exports.openInNewTab = exports.oldest = exports.latest = exports.sortBy = exports.calculateEnergyCompareForThisSystem = exports.generateBinCases = exports.operationTime = exports.annualOperatingCases = exports.annualOperationInputs = exports.costAndEmissionsInformation = exports.emissions = exports.cost = exports.energyInput = exports.systemIsLockedCantCalculateEnergy = exports.calculateEnergyForThisSystem = exports.saveAndCalculate = exports.serviceCalculationFailed = exports.annualEnergyConsumption = exports.annualEnergyCost = exports.tcoYearOnYear = exports.tcoAggregated = exports.preferredResults = exports.operatingScenario = exports.nrOFYearsInTheTco = exports.tcoSelectionsWarning = exports.maxcomparisonlimit = exports.tcoNoSystemsFound = exports.tcoDeletedSystem = void 0;
exports.margin = exports.masterMarginCost = exports.marginCost = exports.extendedInformation = exports.validityWarning = exports.baseComponents = exports.systemCalculation = exports.systemCalculationIsValidUntil = exports.validTime = exports.partPrice = exports.quantityShort = exports.salesOrganisation = exports.selection = exports.endUser = exports.salesOrder = exports.preparedFor = exports.systemName = exports.casings = exports.components = exports.notImplemented = exports.mechanicalView = exports.diagram = exports.currencyHasBeenChanged = exports.locked = exports.revisionLockedMsg = exports.systemMessages = exports.cannotExchangeComponent = exports.exchangeComponent = exports.move = exports.operatingCaseName = exports.partsAndAccessories = exports.engineeringOutputs = exports.systemInputs = exports.addComponent = exports.saveChangesToQuestion = exports.saveChangesQuestion = exports.moreMessages = exports.permissionDenied = exports.message = exports.calcstepAlreadyCompleted = exports.removeFromFavorites = exports.addToFavorites = exports.revisions = exports.lockRevision = exports.calculateMcompare = exports.validateMcompare = exports.saveAndCalculateEnergy = exports.calculateEnergy = exports.calculatePrice = exports.calculateSound = void 0;
exports.mlcLoadOperationTimeOutsideSystemOperationTime = exports.mlcLoadOperationTimeHasNoHours = exports.mlcDuplicatedLoadTypeName = exports.mlcEmptyLoadTypeName = exports.mlcHasToBeLocked = exports.mlcSystemConfiguration = exports.mlcApplicationTypes = exports.mlcNoTargetTemp = exports.mlcNoTargethum = exports.mlcApplicationType = exports.mlcApplicationTypeInfo = exports.mlcBuildingExtended = exports.mlcSystemOperationtime = exports.mlcSystemAndBuildingConfig = exports.mlcSystem = exports.mlcDesiredIndoorsClimate = exports.mclUpdateDefinitions = exports.mclOutOfDate = exports.mlcOutdoorsClimate = exports.mlcUsageStatistics = exports.mlcBuilding = exports.documents = exports.externalNotes = exports.internalNotes = exports.deleteComponent = exports.cannotDeleteComponent = exports.componentCalculationType = exports.calculateToShowDiagram = exports.opCaseResults = exports.resultsSummary = exports.noPerformanceAvailable = exports.showResultFor = exports.calculatingEnergy = exports.systemValidityExpired = exports.systemExpiredRecalculate = exports.systemNotLockedShort = exports.systemNotLocked = exports.isInPricings = exports.mCompareSystem = exports.masterSalesOrganisation = exports.masterCurrency = exports.productText = exports.masterListPrice = exports.listPrice = exports.oemPrice = exports.masterTransferPrice = exports.transferPrice = exports.mczFactoryPrice = exports.consolidatedMargin = exports.refCost = void 0;
exports.globalPropertyDescription = exports.globalPropertyName = exports.deleteAllSelectedMsg = exports.filterOptionsText = exports.shouldBeLessOrEqual = exports.shouldBeLess = exports.shouldBeGreaterOrEqual = exports.shouldBeGreater = exports.shouldBeNotEquals = exports.shouldBeEquals = exports.shouldBeBetweenMinMax = exports.specProp = exports.perfParam = exports.cannotAddProduct = exports.newVersionMessage = exports.mlcSelectDeselectMoistureLoads = exports.mlcSelectDeselectHeatLoads = exports.mlcMoistureHeatLoadTypes = exports.mlcHasNotBeenCalculatedError = exports.mlcLanguage = exports.mlcPapersize = exports.mlcHeaderLabel = exports.mlcReportoptions = exports.mlcviewAs = exports.mlcOk = exports.mlcAccesControl = exports.mlcRename = exports.mlcTransferToUser = exports.mlcCopyLatestRevision = exports.mlcDelete = exports.mlcAssginLabels = exports.mlcCreateNewRevision = exports.mlclatestRevNeedsToBeLocked = exports.mlcBinDataLocation = exports.mlcCreateSystemFromopc = exports.mlcCreateWithSysSel = exports.mlcLoadsWithBoth = exports.mlcLoadsWithHeat = exports.mlcConstantTargetTemp = exports.mlcMaxTargetTemp = exports.mlcMinTargetTemp = exports.mlcLoadsWithMoisture = exports.mlcNoLabelsAssigned = exports.mlOnoeOrMoreMissingLoadsRequired = exports.mlcAddMoistureAndHeaTypes = exports.mlcNoSystemsconnected = exports.mlcSystemOperationTime = exports.mlcSystemConfigurationTypes = exports.mlcManualClimateBinsIncomplete = exports.mlcSystemOperationTimeHasNoHours = void 0;
exports.functionType = exports.calculationProgress = exports.fileFormat = exports.processingToolTip = exports.pricingArticle = exports.errorMessage = exports.dynamicText = void 0;
exports.languageId = languageId;
exports.product = product;
exports.systemTypeProperty = systemTypeProperty;
exports.systemTypePropertyValue = systemTypePropertyValue;
exports.productProperty = productProperty;
exports.productPropertyValue = productPropertyValue;
exports.reportParam = reportParam;
exports.reportParamValue = reportParamValue;
exports.systemTypeIdText = systemTypeIdText;
exports.tabTitleText = tabTitleText;
exports.createTranslateTodoText = createTranslateTodoText;
exports.curlyTranslate = curlyTranslate;
exports.staticText = staticText;
const dhCapacity = () => staticText("dhCapacity");
exports.dhCapacity = dhCapacity;
const systemCreated = () => staticText("systemCreated");
exports.systemCreated = systemCreated;
const preValidation = () => staticText("preValidation");
exports.preValidation = preValidation;
const warnings = () => staticText("warnings");
exports.warnings = warnings;
const errors = () => staticText("errors");
exports.errors = errors;
const variant = () => staticText("variant");
exports.variant = variant;
const calculateSystems = () => staticText("calculateSystems");
exports.calculateSystems = calculateSystems;
const calculating = () => staticText("calculating");
exports.calculating = calculating;
const electricHeater = () => staticText("electricHeater");
exports.electricHeater = electricHeater;
const steamHeater = () => staticText("steamHeater");
exports.steamHeater = steamHeater;
const condenser = () => staticText("condenser");
exports.condenser = condenser;
const pullDownTime = () => staticText("pulldowntime");
exports.pullDownTime = pullDownTime;
const gasHeater = () => staticText("gasheater");
exports.gasHeater = gasHeater;
const labelsmanager = () => staticText("labelsmanager");
exports.labelsmanager = labelsmanager;
const chooseLabels = () => staticText("chooseLabels");
exports.chooseLabels = chooseLabels;
const chooseMonths = () => staticText("chooseMonths");
exports.chooseMonths = chooseMonths;
const edviewreport = () => staticText("edviewreport");
exports.edviewreport = edviewreport;
const edsubmitreport = () => staticText("edsubmitreport");
exports.edsubmitreport = edsubmitreport;
const reportoptions = () => staticText("reportOptions");
exports.reportoptions = reportoptions;
const edreload = () => staticText("edreload");
exports.edreload = edreload;
const edcopyexception = () => staticText("edcopyexception");
exports.edcopyexception = edcopyexception;
const edContinue = () => staticText("edcontinue");
exports.edContinue = edContinue;
const loggedinuser = () => staticText("loggedinuser");
exports.loggedinuser = loggedinuser;
const logintime = () => staticText("logintime");
exports.logintime = logintime;
const logout = () => staticText("logout");
exports.logout = logout;
const systemArrangement = () => staticText("systemarrangement");
exports.systemArrangement = systemArrangement;
const arrangement = () => staticText("arrangement");
exports.arrangement = arrangement;
const systemSettings = () => staticText("systemsettings");
exports.systemSettings = systemSettings;
const quickSelect = () => staticText("quickselect");
exports.quickSelect = quickSelect;
const system = () => staticText("system");
exports.system = system;
const alert = () => staticText("alert");
exports.alert = alert;
const dashboard = () => staticText("dashboard");
exports.dashboard = dashboard;
const favourites = () => staticText("favourites");
exports.favourites = favourites;
const newInHelpDeskHeader = () => staticText("newinhelpdeskheader");
exports.newInHelpDeskHeader = newInHelpDeskHeader;
const systemsmanager = () => staticText("systemsmanager");
exports.systemsmanager = systemsmanager;
const newsystem = () => staticText("newsystem");
exports.newsystem = newsystem;
const pricing = () => staticText("pricing");
exports.pricing = pricing;
const pricingmanager = () => staticText("pricingmanager");
exports.pricingmanager = pricingmanager;
const newPricing = () => staticText("newpricing");
exports.newPricing = newPricing;
const newMoistureLoad = () => staticText("newmoistureload");
exports.newMoistureLoad = newMoistureLoad;
const usersettings = () => staticText("usersettings");
exports.usersettings = usersettings;
const settings = () => staticText("settings");
exports.settings = settings;
const culture = () => staticText("culture");
exports.culture = culture;
const languagecodes = () => staticText("languagecodes");
exports.languagecodes = languagecodes;
const screenamountprofiles = () => staticText("screenamountprofiles");
exports.screenamountprofiles = screenamountprofiles;
const editprofiles = () => staticText("editprofiles");
exports.editprofiles = editprofiles;
const userDefaults = () => staticText("userDefaults");
exports.userDefaults = userDefaults;
const resetuserprofile = () => staticText("resetuserprofile");
exports.resetuserprofile = resetuserprofile;
const reset = () => staticText("reset");
exports.reset = reset;
const resetAll = () => staticText("resetall");
exports.resetAll = resetAll;
const tools = () => staticText("tools");
exports.tools = tools;
const psychrometricChart = () => staticText("PsychrometricChart");
exports.psychrometricChart = psychrometricChart;
const generate = () => staticText("generate");
exports.generate = generate;
const binPage = () => staticText("binpage");
exports.binPage = binPage;
const dryCap = () => staticText("dryCap");
exports.dryCap = dryCap;
const humidityConversion = () => staticText("HumidityConversion");
exports.humidityConversion = humidityConversion;
const density = () => staticText("density");
exports.density = density;
const fanChart = () => staticText("FanChart");
exports.fanChart = fanChart;
const airMixer = () => staticText("AirMixer");
exports.airMixer = airMixer;
const air1 = () => staticText("air1");
exports.air1 = air1;
const air2 = () => staticText("air2");
exports.air2 = air2;
const condensation = () => staticText("condensation");
exports.condensation = condensation;
const airPowerTool = () => staticText("AirPowerTool");
exports.airPowerTool = airPowerTool;
const airIn = () => staticText("airin");
exports.airIn = airIn;
const airOut = () => staticText("airout");
exports.airOut = airOut;
const flow = () => staticText("flow");
exports.flow = flow;
const pressure = () => staticText("pressure");
exports.pressure = pressure;
const power = () => staticText("power");
exports.power = power;
const calculateAirOut = () => staticText("calculateairout");
exports.calculateAirOut = calculateAirOut;
const calculatePower = () => staticText("calculatepower");
exports.calculatePower = calculatePower;
const coilProTool = () => staticText("CoilProTool");
exports.coilProTool = coilProTool;
const fanProTool = () => staticText("FanProTool");
exports.fanProTool = fanProTool;
const fanMotorProTool = () => staticText("FanMotorProTool");
exports.fanMotorProTool = fanMotorProTool;
const nevadaTestSite = () => staticText("NevadaTestSite");
exports.nevadaTestSite = nevadaTestSite;
const sycoolTool = () => staticText("SycoolTool");
exports.sycoolTool = sycoolTool;
const dataCenterWizard = () => staticText("DataCenterWizard");
exports.dataCenterWizard = dataCenterWizard;
const iceDryTool = () => staticText("IceDryTool");
exports.iceDryTool = iceDryTool;
const usagestatistics = () => staticText("usagestatistics");
exports.usagestatistics = usagestatistics;
const viewEffectiveClaims = () => staticText("ViewEffectiveClaims");
exports.viewEffectiveClaims = viewEffectiveClaims;
const viewAll = () => staticText("ViewAll");
exports.viewAll = viewAll;
const advancedProductSearch = () => staticText("AdvancedProductSearch");
exports.advancedProductSearch = advancedProductSearch;
const tAndCAcceptanceStatus = () => staticText("tandcacceptancestatus");
exports.tAndCAcceptanceStatus = tAndCAcceptanceStatus;
const translationSearch = () => staticText("translationsearch");
exports.translationSearch = translationSearch;
const moistureLoad = () => staticText("moistureload");
exports.moistureLoad = moistureLoad;
const moistureLoadName = () => staticText("moistureloadname");
exports.moistureLoadName = moistureLoadName;
const moistureLoadCreated = () => staticText("moistureloadcreated");
exports.moistureLoadCreated = moistureLoadCreated;
const moistureLoadNo = () => staticText("moistureloadno");
exports.moistureLoadNo = moistureLoadNo;
const connectSystemTomlc = () => staticText("connectsystemtomlc");
exports.connectSystemTomlc = connectSystemTomlc;
const opcMlcImportText = () => staticText("opcmlcimporttext");
exports.opcMlcImportText = opcMlcImportText;
const moistureLoadCalculation = () => staticText("MoistureLoadCalculation");
exports.moistureLoadCalculation = moistureLoadCalculation;
const drysize = () => staticText("drysize");
exports.drysize = drysize;
const moistureLoadManager = () => staticText("moistureloadmanager");
exports.moistureLoadManager = moistureLoadManager;
const newMoistureLoadCalc = () => staticText("newmoistureloadcalc");
exports.newMoistureLoadCalc = newMoistureLoadCalc;
const errorreports = () => staticText("errorreports");
exports.errorreports = errorreports;
const startpage = () => staticText("startpage");
exports.startpage = startpage;
const about = () => staticText("about");
exports.about = about;
const abort = () => staticText("abort");
exports.abort = abort;
const calculatingEnergyCase = () => staticText("calculatingenergycase");
exports.calculatingEnergyCase = calculatingEnergyCase;
const changelog = () => staticText("changelog");
exports.changelog = changelog;
const requestAccessLevel = () => staticText("requestAccessLevel");
exports.requestAccessLevel = requestAccessLevel;
const wiki = () => staticText("wiki");
exports.wiki = wiki;
const legacyClient = () => staticText("legacyclient");
exports.legacyClient = legacyClient;
const instructionVideos = () => staticText("instructionvideos");
exports.instructionVideos = instructionVideos;
const maintenance = () => staticText("maintenance");
exports.maintenance = maintenance;
const helpmenu = () => staticText("helpmenu");
exports.helpmenu = helpmenu;
const confirmresetallsettings = () => staticText("confirmresetallsettings");
exports.confirmresetallsettings = confirmresetallsettings;
const yes = () => staticText("yes");
exports.yes = yes;
const no = () => staticText("no");
exports.no = no;
const ok = () => staticText("ok");
exports.ok = ok;
const update = () => staticText("update");
exports.update = update;
const confirmation = () => staticText("confirmation");
exports.confirmation = confirmation;
const open = () => staticText("open");
exports.open = open;
const language = () => staticText("language");
exports.language = language;
const currency = () => staticText("currency");
exports.currency = currency;
const measuresystem = () => staticText("measuresystem");
exports.measuresystem = measuresystem;
const dateTimeNumberFormat = () => staticText("dateTimeNumberFormat");
exports.dateTimeNumberFormat = dateTimeNumberFormat;
const country = () => staticText("country");
exports.country = country;
const state = () => staticText("state");
exports.state = state;
const location = () => staticText("location");
exports.location = location;
const fileformat = () => staticText("fileformat");
exports.fileformat = fileformat;
const papersize = () => staticText("papersize");
exports.papersize = papersize;
const headerLabel = () => staticText("headerlabel");
exports.headerLabel = headerLabel;
const printData = () => staticText("printdata");
exports.printData = printData;
const load = () => staticText("load");
exports.load = load;
const latitude = () => staticText("latitude");
exports.latitude = latitude;
const longitude = () => staticText("longitude");
exports.longitude = longitude;
const recentsystemsheader = () => staticText("recentsystemsheader");
exports.recentsystemsheader = recentsystemsheader;
const showallrecentlychangedsystems = () => staticText("showallrecentlychangedsystems");
exports.showallrecentlychangedsystems = showallrecentlychangedsystems;
const lastChange = () => staticText("LastChange");
exports.lastChange = lastChange;
const systems = () => staticText("Systems");
exports.systems = systems;
const systemsFromMySystems = () => staticText("systemsFromMySystems");
exports.systemsFromMySystems = systemsFromMySystems;
const systemsFromAllSystems = () => staticText("systemsFromAllSystems");
exports.systemsFromAllSystems = systemsFromAllSystems;
const elevation = () => staticText("elevation");
exports.elevation = elevation;
const name = () => staticText("name");
exports.name = name;
const type = () => staticText("type");
exports.type = type;
const measureSystem = () => staticText("measuresystem");
exports.measureSystem = measureSystem;
const edit = () => staticText("edit");
exports.edit = edit;
const del = () => staticText("delete");
exports.del = del;
const close = () => staticText("close");
exports.close = close;
const cancel = () => staticText("cancel");
exports.cancel = cancel;
const assign = () => staticText("assign");
exports.assign = assign;
const back = () => staticText("back");
exports.back = back;
const select = () => staticText("select");
exports.select = select;
const selected = () => staticText("selected");
exports.selected = selected;
const save = () => staticText("save");
exports.save = save;
const newText = () => staticText("new");
exports.newText = newText;
const createProfile = () => staticText("createnewprofile");
exports.createProfile = createProfile;
const unsupportedBrowser = () => staticText("unsupportedbrowser");
exports.unsupportedBrowser = unsupportedBrowser;
const browserinformation = () => staticText("browserinformation");
exports.browserinformation = browserinformation;
const defaultCurrency = () => staticText("defaultCurrency");
exports.defaultCurrency = defaultCurrency;
const defaultSalesOrganisation = () => staticText("defaultSalesOrganisation");
exports.defaultSalesOrganisation = defaultSalesOrganisation;
const deleteArticle = () => staticText("deletearticle");
exports.deleteArticle = deleteArticle;
const deleteArticleConfirm = () => staticText("deletearticleconfirm");
exports.deleteArticleConfirm = deleteArticleConfirm;
const changed = () => staticText("changed");
exports.changed = changed;
const owner = () => staticText("owner");
exports.owner = owner;
const you = () => staticText("you");
exports.you = you;
const value = () => staticText("value");
exports.value = value;
const subject = () => staticText("subject");
exports.subject = subject;
const allowedUsers = () => staticText("allowedusers");
exports.allowedUsers = allowedUsers;
const allowedClaims = () => staticText("allowedclaims");
exports.allowedClaims = allowedClaims;
const status = () => staticText("status");
exports.status = status;
const labels = () => staticText("labels");
exports.labels = labels;
const rename = () => staticText("rename");
exports.rename = rename;
const assignlabels = () => staticText("assignlabels");
exports.assignlabels = assignlabels;
const editLabels = () => staticText("editlabels");
exports.editLabels = editLabels;
const copylatestrevision = () => staticText("copylatestrevision");
exports.copylatestrevision = copylatestrevision;
const createnewrevision = () => staticText("createnewrevision");
exports.createnewrevision = createnewrevision;
const transfertouser = () => staticText("transfertouser");
exports.transfertouser = transfertouser;
const confirmdeletelong = () => staticText("confirmdeletelong");
exports.confirmdeletelong = confirmdeletelong;
const confirmdelete = () => staticText("confirmdelete");
exports.confirmdelete = confirmdelete;
const allLabels = () => staticText("alllabels");
exports.allLabels = allLabels;
const assignedLabels = () => staticText("assignedlabels");
exports.assignedLabels = assignedLabels;
const createNewLabel = () => staticText("createnewlabel");
exports.createNewLabel = createNewLabel;
const newLabel = () => staticText("newlabel");
exports.newLabel = newLabel;
const labelName = () => staticText("labelname");
exports.labelName = labelName;
const createNewSystem = () => staticText("createnewsystem");
exports.createNewSystem = createNewSystem;
const noFavoritesMsg = () => staticText("nofavoritesmsg");
exports.noFavoritesMsg = noFavoritesMsg;
const noRecentSystemsMsg = () => staticText("norecentsystemsmsg");
exports.noRecentSystemsMsg = noRecentSystemsMsg;
const helpCenter = () => staticText("helpcenter");
exports.helpCenter = helpCenter;
const traningVideos = () => staticText("traningvideos");
exports.traningVideos = traningVideos;
const faq = () => staticText("faqs");
exports.faq = faq;
const systemInformation = () => staticText("systeminformation");
exports.systemInformation = systemInformation;
const changeLog = () => staticText("changelog");
exports.changeLog = changeLog;
const showAll = () => staticText("showall");
exports.showAll = showAll;
const showLess = () => staticText("showless");
exports.showLess = showLess;
const showUnassigned = () => staticText("showunassigned");
exports.showUnassigned = showUnassigned;
const noAssignedLabels = () => staticText("noassignedlabels");
exports.noAssignedLabels = noAssignedLabels;
const enterFileNameHere = () => staticText("enterFileNameHere");
exports.enterFileNameHere = enterFileNameHere;
const date = () => staticText("date");
exports.date = date;
const from = () => staticText("from");
exports.from = from;
const to = () => staticText("to");
exports.to = to;
const clear = () => staticText("clear");
exports.clear = clear;
const saveAsPrecheckedDefault = () => staticText("saveAsPrecheckedDefault");
exports.saveAsPrecheckedDefault = saveAsPrecheckedDefault;
const helpAboutSearching = () => staticText("helpaboutsearching");
exports.helpAboutSearching = helpAboutSearching;
const of = () => staticText("of");
exports.of = of;
const pages = () => staticText("pages");
exports.pages = pages;
const myPricings = () => staticText("mypricings");
exports.myPricings = myPricings;
const myMoistureLoad = () => staticText("mymoistureload");
exports.myMoistureLoad = myMoistureLoad;
const allMoistureLoads = () => staticText("allmoistureloads");
exports.allMoistureLoads = allMoistureLoads;
const allPricings = () => staticText("allpricings");
exports.allPricings = allPricings;
const mySystems = () => staticText("mysystems");
exports.mySystems = mySystems;
const allSystems = () => staticText("allsystems");
exports.allSystems = allSystems;
const latestRevNeedsToBeLocked = () => staticText("latestrevneedstobelocked");
exports.latestRevNeedsToBeLocked = latestRevNeedsToBeLocked;
const copyTransferOpen = () => staticText("copytransferopen");
exports.copyTransferOpen = copyTransferOpen;
const editComment = () => staticText("editcomment");
exports.editComment = editComment;
const comment = () => staticText("comment");
exports.comment = comment;
const nocomment = () => staticText("nocomment");
exports.nocomment = nocomment;
const createPricingAndAdd = () => staticText("createpricingandadd");
exports.createPricingAndAdd = createPricingAndAdd;
const recoverSystem = () => staticText("recoversystem");
exports.recoverSystem = recoverSystem;
const deletedBy = () => staticText("deletedby");
exports.deletedBy = deletedBy;
const moreActions = () => staticText("moreactions");
exports.moreActions = moreActions;
const exportText = () => staticText("export");
exports.exportText = exportText;
const importText = () => staticText("import");
exports.importText = importText;
const exampleTemplate = () => staticText("exampletemplate");
exports.exampleTemplate = exampleTemplate;
const summary = () => staticText("summary");
exports.summary = summary;
const projectSelection = () => staticText("projectselection");
exports.projectSelection = projectSelection;
const systemCompare = () => staticText("systemcompare");
exports.systemCompare = systemCompare;
const exportSketch = () => staticText("exportsketch");
exports.exportSketch = exportSketch;
const cannotShowMechanicalSketchMsg = () => staticText("cannotshowmechanicalsketchmsg");
exports.cannotShowMechanicalSketchMsg = cannotShowMechanicalSketchMsg;
const cannotShowMechanicalSketchStaticMsg = () => staticText("cannotshowmechanicalsketchstaticmsg");
exports.cannotShowMechanicalSketchStaticMsg = cannotShowMechanicalSketchStaticMsg;
const actions = () => staticText("actions");
exports.actions = actions;
const systemsPerPage = () => staticText("systemsperpage");
exports.systemsPerPage = systemsPerPage;
const usingLabels = () => staticText("usinglabels");
exports.usingLabels = usingLabels;
const usingLabelsMsg = () => staticText("usinglabelsmsg");
exports.usingLabelsMsg = usingLabelsMsg;
const createNew = () => staticText("createnew");
exports.createNew = createNew;
const deleteText = () => staticText("delete");
exports.deleteText = deleteText;
const deleteLabelMsg = (labelName) => staticTextWithParams("deletelabelmsg", labelName);
exports.deleteLabelMsg = deleteLabelMsg;
const confirm = () => staticText("confirm");
exports.confirm = confirm;
const continueText = () => staticText("continue");
exports.continueText = continueText;
const stopCalculations = () => staticText("stopcalculations");
exports.stopCalculations = stopCalculations;
const buildState = () => staticText("buildState");
exports.buildState = buildState;
const longRunningTask = () => staticText("longRunningTask");
exports.longRunningTask = longRunningTask;
const couldNotBuild = () => staticText("couldNotBuild");
exports.couldNotBuild = couldNotBuild;
const requestBuild = () => staticText("requestBuild");
exports.requestBuild = requestBuild;
const refresh = () => staticText("refresh");
exports.refresh = refresh;
const piece = () => staticText("piece");
exports.piece = piece;
const article = () => staticText("article");
exports.article = article;
const header = () => staticText("header");
exports.header = header;
const articleGroup = () => staticText("articlegroup");
exports.articleGroup = articleGroup;
const rowNo = () => staticText("rowno");
exports.rowNo = rowNo;
const articleNo = () => staticText("articleno");
exports.articleNo = articleNo;
const add = () => staticText("add");
exports.add = add;
const pricingCurrency = () => staticText("pricingCurrency");
exports.pricingCurrency = pricingCurrency;
const salesorg = () => staticText("salesorg");
exports.salesorg = salesorg;
const group = () => staticText("group");
exports.group = group;
const description = () => staticText("description");
exports.description = description;
const pidshort = () => staticText("pidshort");
exports.pidshort = pidshort;
const caseshort = () => staticText("caseshort");
exports.caseshort = caseshort;
const quantity = () => staticText("quantity");
exports.quantity = quantity;
const unit = () => staticText("unit");
exports.unit = unit;
const costPerUnit = () => staticText("costperunit");
exports.costPerUnit = costPerUnit;
const priceFactor = () => staticText("pricefactor");
exports.priceFactor = priceFactor;
const transferPriceFactor = () => staticText("transferpricefactor");
exports.transferPriceFactor = transferPriceFactor;
const listPriceFactor = () => staticText("listpricefactor");
exports.listPriceFactor = listPriceFactor;
const pricePerUnit = () => staticText("pricePerUnit");
exports.pricePerUnit = pricePerUnit;
const transferPricePerUnit = () => staticText("transferpriceperunit");
exports.transferPricePerUnit = transferPricePerUnit;
const listPricePerUnit = () => staticText("listpriceperunit");
exports.listPricePerUnit = listPricePerUnit;
const discountPercent = () => staticText("discountpercent");
exports.discountPercent = discountPercent;
const total = () => staticText("total");
exports.total = total;
const costSubtotal = () => staticText("costsubtotal");
exports.costSubtotal = costSubtotal;
const priceSubtotal = () => staticText("pricesubtotal");
exports.priceSubtotal = priceSubtotal;
const transferPriceSubtotal = () => staticText("transferpricesubtotal");
exports.transferPriceSubtotal = transferPriceSubtotal;
const listPriceSubtotal = () => staticText("listpricesubtotal");
exports.listPriceSubtotal = listPriceSubtotal;
const notes = () => staticText("notes");
exports.notes = notes;
const goToProductPage = () => staticText("gotoproductpage");
exports.goToProductPage = goToProductPage;
const componentSpec = () => staticText("componentspec");
exports.componentSpec = componentSpec;
const totalPrice = () => staticText("totalprice");
exports.totalPrice = totalPrice;
const totalListPrice = () => staticText("totallistprice");
exports.totalListPrice = totalListPrice;
const totalTransferPrice = () => staticText("totaltransferprice");
exports.totalTransferPrice = totalTransferPrice;
const totalMarginPercent = () => staticText("totalmarginpercent");
exports.totalMarginPercent = totalMarginPercent;
const lockPricing = () => staticText("lockpricing");
exports.lockPricing = lockPricing;
const printPreview = () => staticText("printpreview");
exports.printPreview = printPreview;
const includeCost = () => staticText("includecost");
exports.includeCost = includeCost;
const includeMargin = () => staticText("includemargin");
exports.includeMargin = includeMargin;
const includePricePerUnit = () => staticText("includepriceperunit");
exports.includePricePerUnit = includePricePerUnit;
const includeListPrice = () => staticText("includelistprice");
exports.includeListPrice = includeListPrice;
const includeTransferPrice = () => staticText("includetransferprice");
exports.includeTransferPrice = includeTransferPrice;
const includePriceSubtotal = () => staticText("includepricesubtotal");
exports.includePriceSubtotal = includePriceSubtotal;
const includeTotalPrice = () => staticText("includetotalprice");
exports.includeTotalPrice = includeTotalPrice;
const lockingPricingInfo = () => staticText("lockingpricinginfo");
exports.lockingPricingInfo = lockingPricingInfo;
const deleteAllRows = () => staticText("deleteallrows");
exports.deleteAllRows = deleteAllRows;
const deleteRow = () => staticText("deleterow");
exports.deleteRow = deleteRow;
const deleteRowConfirm = () => staticText("deleterowconfirm");
exports.deleteRowConfirm = deleteRowConfirm;
const deleteAllRowsConfirm = () => staticText("deleteallrowsconfirm");
exports.deleteAllRowsConfirm = deleteAllRowsConfirm;
const search = () => staticText("search");
exports.search = search;
const genesysNo = () => staticText("genesysno");
exports.genesysNo = genesysNo;
const pricingNoSystemFound = () => staticText("pricingnosystemfound");
exports.pricingNoSystemFound = pricingNoSystemFound;
const pricingReport = () => staticText("pricingreport");
exports.pricingReport = pricingReport;
const savePricingToCreateReport = () => staticText("savepricingtocreatereport");
exports.savePricingToCreateReport = savePricingToCreateReport;
const preview = () => staticText("preview");
exports.preview = preview;
const download = () => staticText("download");
exports.download = download;
const rebuild = () => staticText("rebuild");
exports.rebuild = rebuild;
const upload = () => staticText("upload");
exports.upload = upload;
const downloadDotDotDot = () => staticText("downloaddotdotdot");
exports.downloadDotDotDot = downloadDotDotDot;
const newRow = () => staticText("newrow");
exports.newRow = newRow;
const create = () => staticText("create");
exports.create = create;
const createPDF = () => staticText("createpdf");
exports.createPDF = createPDF;
const createDocx = () => staticText("createdocx");
exports.createDocx = createDocx;
const generating = () => staticText("generating");
exports.generating = generating;
const coils = () => staticText("coils");
exports.coils = coils;
const preCoil = () => staticText("precoil");
exports.preCoil = preCoil;
const blendCoil = () => staticText("blendcoil");
exports.blendCoil = blendCoil;
const postCoil = () => staticText("postcoil");
exports.postCoil = postCoil;
const moistureCapacity = () => staticText("moisturecapacity");
exports.moistureCapacity = moistureCapacity;
const pricingName = () => staticText("pricingname");
exports.pricingName = pricingName;
const moistureloadName = () => staticText("moistureloadname");
exports.moistureloadName = moistureloadName;
const nameAndLabels = () => staticText("nameandlabels");
exports.nameAndLabels = nameAndLabels;
const selectProductRange = () => staticText("selectproductrange");
exports.selectProductRange = selectProductRange;
const selectSystemSize = () => staticText("selectsystemsize");
exports.selectSystemSize = selectSystemSize;
const previous = () => staticText("Previous");
exports.previous = previous;
const next = () => staticText("Next");
exports.next = next;
const nextStep = () => staticText("nextstep");
exports.nextStep = nextStep;
const finish = () => staticText("finish");
exports.finish = finish;
const supplyHumidity = () => staticText("supplyhumidity");
exports.supplyHumidity = supplyHumidity;
const supplyAirFlow = () => staticText("supplyairflow");
exports.supplyAirFlow = supplyAirFlow;
const initialConfiguration = () => staticText("initialconfiguration");
exports.initialConfiguration = initialConfiguration;
const calculateMoistureLoad = () => staticText("calculatemoistureload");
exports.calculateMoistureLoad = calculateMoistureLoad;
const products = () => staticText("products");
exports.products = products;
const noVariantsGenerated = () => staticText("novariantsgenerated");
exports.noVariantsGenerated = noVariantsGenerated;
const purgeTypes = () => staticText("purgetypes");
exports.purgeTypes = purgeTypes;
const allCalculationsFailed = () => staticText("allcalculationsfailed");
exports.allCalculationsFailed = allCalculationsFailed;
const operatingCases = () => staticText("operatingcases");
exports.operatingCases = operatingCases;
const sizeSelection = () => staticText("sizeselection");
exports.sizeSelection = sizeSelection;
const serviceCalculation = () => staticText("servicecalculation");
exports.serviceCalculation = serviceCalculation;
const serviceCalculationNotLocked = () => staticText("serviceCalculationNotLocked");
exports.serviceCalculationNotLocked = serviceCalculationNotLocked;
const dehumidifier = () => staticText("Dehumidifier");
exports.dehumidifier = dehumidifier;
const plenum = () => staticText("plenum");
exports.plenum = plenum;
const model = () => staticText("model");
exports.model = model;
const purge = () => staticText("purge");
exports.purge = purge;
const reactHeaterPower = () => staticText("reactheaterpower");
exports.reactHeaterPower = reactHeaterPower;
const totalCoolingPower = () => staticText("totalcoolingpower");
exports.totalCoolingPower = totalCoolingPower;
const faceArea = () => staticText("facearea");
exports.faceArea = faceArea;
const velocity = () => staticText("velocity");
exports.velocity = velocity;
const minVelocity = () => staticText("minvelocity");
exports.minVelocity = minVelocity;
const maxVelocity = () => staticText("maxvelocity");
exports.maxVelocity = maxVelocity;
const targetPower = () => staticText("targetpower");
exports.targetPower = targetPower;
const noSizesFoundForVelocity = () => staticText("nosizesfoundforvelocity");
exports.noSizesFoundForVelocity = noSizesFoundForVelocity;
const selectLocation = () => staticText("selectlocation");
exports.selectLocation = selectLocation;
const error = () => staticText("error");
exports.error = error;
const or = () => staticText("or");
exports.or = or;
const and = () => staticText("and");
exports.and = and;
const pNull = () => staticText("p_null");
exports.pNull = pNull;
const na2SsFilters = () => staticText("NA2_SS_Filters");
exports.na2SsFilters = na2SsFilters;
const na2SsCoils = () => staticText("NA2_SS_Coils");
exports.na2SsCoils = na2SsCoils;
const na2SsHumidifier = () => staticText("NA2_SS_Humidifier");
exports.na2SsHumidifier = na2SsHumidifier;
const na2SsAirflows = () => staticText("NA2_SS_Airflows");
exports.na2SsAirflows = na2SsAirflows;
const na2SsSize1 = () => staticText("NA2_SS_Size_1");
exports.na2SsSize1 = na2SsSize1;
const na2SsSize2 = () => staticText("NA2_SS_Size_2");
exports.na2SsSize2 = na2SsSize2;
const na2SsEmpty1 = () => staticText("NA2_SS_Empty_1");
exports.na2SsEmpty1 = na2SsEmpty1;
const na2SsEmpty2 = () => staticText("NA2_SS_Empty_2");
exports.na2SsEmpty2 = na2SsEmpty2;
const na2SsMax = () => staticText("NA2_SS_Max");
exports.na2SsMax = na2SsMax;
const na2SsNoMax = () => staticText("NA2_SS_NoMax");
exports.na2SsNoMax = na2SsNoMax;
const na2SsFilter1 = () => staticText("NA2_SS_Filter_1");
exports.na2SsFilter1 = na2SsFilter1;
const na2SsFilter2 = () => staticText("NA2_SS_Filter_2");
exports.na2SsFilter2 = na2SsFilter2;
const na2SsAbsFilter1 = () => staticText("NA2_SS_AbsFilter_1");
exports.na2SsAbsFilter1 = na2SsAbsFilter1;
const na2SsAbsFilter2 = () => staticText("NA2_SS_AbsFilter_2");
exports.na2SsAbsFilter2 = na2SsAbsFilter2;
const na2SsCarFilter1 = () => staticText("NA2_SS_CarFilter_1");
exports.na2SsCarFilter1 = na2SsCarFilter1;
const na2SsCarFilter2 = () => staticText("NA2_SS_CarFilter_2");
exports.na2SsCarFilter2 = na2SsCarFilter2;
const na2SsHeatCoil1 = () => staticText("NA2_SS_HeatCoil_1");
exports.na2SsHeatCoil1 = na2SsHeatCoil1;
const na2SsCoolCoil1 = () => staticText("NA2_SS_CoolCoil_1");
exports.na2SsCoolCoil1 = na2SsCoolCoil1;
const na2SsHumidifier1 = () => staticText("NA2_SS_Humidifier_1");
exports.na2SsHumidifier1 = na2SsHumidifier1;
const na2SsMinFlow1 = () => staticText("NA2_SS_MinFlow_1");
exports.na2SsMinFlow1 = na2SsMinFlow1;
const na2SsMinFlow2 = () => staticText("NA2_SS_MinFlow_2");
exports.na2SsMinFlow2 = na2SsMinFlow2;
const na2SsMaxFlow1 = () => staticText("NA2_SS_MaxFlow_1");
exports.na2SsMaxFlow1 = na2SsMaxFlow1;
const na2SsMaxFlow2 = () => staticText("NA2_SS_MaxFlow_2");
exports.na2SsMaxFlow2 = na2SsMaxFlow2;
const na2SsBox = () => staticText("NA2_SS_Box");
exports.na2SsBox = na2SsBox;
const na2SsExternalHeight = () => staticText("NA2_SSExternalHeight");
exports.na2SsExternalHeight = na2SsExternalHeight;
const na2SsExternalWidth = () => staticText("NA2_SSExternalWidth");
exports.na2SsExternalWidth = na2SsExternalWidth;
const na2SsBaseFrameHeight = () => staticText("NA2_SSBaseFrameHeight");
exports.na2SsBaseFrameHeight = na2SsBaseFrameHeight;
const na2SsEurovent = () => staticText("NA2_SS_Eurovent");
exports.na2SsEurovent = na2SsEurovent;
const dimensions = () => staticText("dimensions");
exports.dimensions = dimensions;
const dcProjectInput = () => staticText("dc_projectinput");
exports.dcProjectInput = dcProjectInput;
const dcRange = () => staticText("dc_range");
exports.dcRange = dcRange;
const dcProjectInfo = () => staticText("dc_projectinfo");
exports.dcProjectInfo = dcProjectInfo;
const dcOutdoorSummer = () => staticText("dc_outdoorsummer");
exports.dcOutdoorSummer = dcOutdoorSummer;
const dcSuggest = () => staticText("dc_suggest");
exports.dcSuggest = dcSuggest;
const dcSuggestedUnits = () => staticText("dc_suggestedunits");
exports.dcSuggestedUnits = dcSuggestedUnits;
const dcEpxSize = () => staticText("dc_epxsize");
exports.dcEpxSize = dcEpxSize;
const projectName = () => staticText("projectname");
exports.projectName = projectName;
const noAdditionalLabelsAssigned = () => staticText("noadditionallabelsassigned");
exports.noAdditionalLabelsAssigned = noAdditionalLabelsAssigned;
const editAdditionalLabels = () => staticText("editadditionallabels");
exports.editAdditionalLabels = editAdditionalLabels;
const powerPerUnit = () => staticText("powerperunit");
exports.powerPerUnit = powerPerUnit;
const flowPerUnit = () => staticText("flowperunit");
exports.flowPerUnit = flowPerUnit;
const unitNominalAirflow = () => staticText("unitnominalairflow");
exports.unitNominalAirflow = unitNominalAirflow;
const maxPowerPerUnit = () => staticText("maxpowerperunit");
exports.maxPowerPerUnit = maxPowerPerUnit;
const requiredNumberOfUnits = () => staticText("requirednumberofunits");
exports.requiredNumberOfUnits = requiredNumberOfUnits;
const suggestedNumberOfUnits = () => staticText("suggestednumberofunits");
exports.suggestedNumberOfUnits = suggestedNumberOfUnits;
const totalMaxPower = () => staticText("totalmaxpower");
exports.totalMaxPower = totalMaxPower;
const configurationName = () => staticText("configurationname");
exports.configurationName = configurationName;
const numberOfUnits = () => staticText("numberofunits");
exports.numberOfUnits = numberOfUnits;
const unitsDefined = () => staticText("unitsdefined");
exports.unitsDefined = unitsDefined;
const redundant = () => staticText("redundant");
exports.redundant = redundant;
const projectIdAlreadyExists = () => staticText("projectidalreadyexists");
exports.projectIdAlreadyExists = projectIdAlreadyExists;
const inputs = () => staticText("inputs");
exports.inputs = inputs;
const results = () => staticText("results");
exports.results = results;
const selectedSystems = () => staticText("selectedsystems");
exports.selectedSystems = selectedSystems;
const binId = () => staticText("binid");
exports.binId = binId;
const binLocation = () => staticText("binlocation");
exports.binLocation = binLocation;
const binSize = () => staticText("binsize");
exports.binSize = binSize;
const binCases = () => staticText("bincases");
exports.binCases = binCases;
const binCasesMissing = () => staticText("bincasesmissing");
exports.binCasesMissing = binCasesMissing;
const energySumSystemStatus = () => staticText("energysumsystemstatus");
exports.energySumSystemStatus = energySumSystemStatus;
const noEnergyResultAvailable = () => staticText("noenergyresultavailable");
exports.noEnergyResultAvailable = noEnergyResultAvailable;
const noTcoResultAvailable = () => staticText("notcoresultavailable");
exports.noTcoResultAvailable = noTcoResultAvailable;
const noEnergySumResultAvailable = () => staticText("noenergysumresultavailable");
exports.noEnergySumResultAvailable = noEnergySumResultAvailable;
const energyNotCalculated = () => staticText("energynotcalculated");
exports.energyNotCalculated = energyNotCalculated;
const energyNotCalculatedShort = () => staticText("energynotcalculatedshort");
exports.energyNotCalculatedShort = energyNotCalculatedShort;
const systemStatusTooLowMsg = () => staticText("tcosystemstatustoolowmsg");
exports.systemStatusTooLowMsg = systemStatusTooLowMsg;
const predictedAnnualConsumption = () => staticText("predictedannualconsumption");
exports.predictedAnnualConsumption = predictedAnnualConsumption;
const predictedAnnualEmission = () => staticText("predictedannualemission");
exports.predictedAnnualEmission = predictedAnnualEmission;
const predictedAnnualCost = () => staticText("predictedannualcost");
exports.predictedAnnualCost = predictedAnnualCost;
const predictedAnnualExtra = () => staticText("predictedannualextra");
exports.predictedAnnualExtra = predictedAnnualExtra;
const predictedLccCost = () => staticText("predictedlcccost");
exports.predictedLccCost = predictedLccCost;
const detailedResults = () => staticText("detailedresults");
exports.detailedResults = detailedResults;
const print = () => staticText("print");
exports.print = print;
const viewAs = () => staticText("viewas");
exports.viewAs = viewAs;
const list = () => staticText("list");
exports.list = list;
const chart = () => staticText("chart");
exports.chart = chart;
const months = () => staticText("months");
exports.months = months;
const month = () => staticText("month");
exports.month = month;
const bins = () => staticText("bins");
exports.bins = bins;
const binViewStandard = () => staticText("binviewstandard");
exports.binViewStandard = binViewStandard;
const binViewWithMonths = () => staticText("binviewwithmonths");
exports.binViewWithMonths = binViewWithMonths;
const chartPreset = () => staticText("chartpreset");
exports.chartPreset = chartPreset;
const chartXAxis = () => staticText("chartxaxis");
exports.chartXAxis = chartXAxis;
const midPointTemp = () => staticText("MidPointTemp");
exports.midPointTemp = midPointTemp;
const midPointWetTemp = () => staticText("MidPointWetTemp");
exports.midPointWetTemp = midPointWetTemp;
const midPointDewPointTemp = () => staticText("MidPointDewPointTemp");
exports.midPointDewPointTemp = midPointDewPointTemp;
const midPointHumidityRatio = () => staticText("midpointhumidityratio");
exports.midPointHumidityRatio = midPointHumidityRatio;
const midPointHourly = () => staticText("midpointhourly");
exports.midPointHourly = midPointHourly;
const midPointSpecificEnthalpy = () => staticText("MidPointSpecificEnthalpy");
exports.midPointSpecificEnthalpy = midPointSpecificEnthalpy;
const averageTemp = () => staticText("AverageTemp");
exports.averageTemp = averageTemp;
const humidity = () => staticText("Humidity");
exports.humidity = humidity;
const averageHumidity = () => staticText("averagehumidity");
exports.averageHumidity = averageHumidity;
const averageSpecificEnthalpy = () => staticText("averagespecificenthalpy");
exports.averageSpecificEnthalpy = averageSpecificEnthalpy;
const returnTemp = () => staticText("returnTemp");
exports.returnTemp = returnTemp;
const returnHumidity = () => staticText("returnHumidity");
exports.returnHumidity = returnHumidity;
const targetTemp = () => staticText("targetTemp");
exports.targetTemp = targetTemp;
const targetHumidity = () => staticText("targetHumidity");
exports.targetHumidity = targetHumidity;
const time = () => staticText("Time");
exports.time = time;
const exportBinsAsStandard = () => staticText("exportbinsasstandard");
exports.exportBinsAsStandard = exportBinsAsStandard;
const mlcExportResults = () => staticText("mlcexportresults");
exports.mlcExportResults = mlcExportResults;
const exportBinsWithMonths = () => staticText("exportbinswithmonths");
exports.exportBinsWithMonths = exportBinsWithMonths;
const januaryHours = () => staticText("januaryhours");
exports.januaryHours = januaryHours;
const februaryHours = () => staticText("februaryhours");
exports.februaryHours = februaryHours;
const marchHours = () => staticText("marchhours");
exports.marchHours = marchHours;
const aprilHours = () => staticText("aprilhours");
exports.aprilHours = aprilHours;
const mayHours = () => staticText("mayhours");
exports.mayHours = mayHours;
const juneHours = () => staticText("junehours");
exports.juneHours = juneHours;
const julyHours = () => staticText("julyhours");
exports.julyHours = julyHours;
const augustHours = () => staticText("augusthours");
exports.augustHours = augustHours;
const septemberHours = () => staticText("septemberhours");
exports.septemberHours = septemberHours;
const octoberHours = () => staticText("octoberhours");
exports.octoberHours = octoberHours;
const novemberHours = () => staticText("novemberhours");
exports.novemberHours = novemberHours;
const decemberHours = () => staticText("decemberhours");
exports.decemberHours = decemberHours;
const wind = () => staticText("Wind");
exports.wind = wind;
const binPressure = () => staticText("BinPressure");
exports.binPressure = binPressure;
const dataType = () => staticText("datatype");
exports.dataType = dataType;
const binOn = () => staticText("binon");
exports.binOn = binOn;
const temperature = () => staticText("temperature");
exports.temperature = temperature;
const screens = () => staticText("screens");
exports.screens = screens;
const processingsteps = () => staticText("processingsteps");
exports.processingsteps = processingsteps;
const systemDiagram = () => staticText("SystemDiagram");
exports.systemDiagram = systemDiagram;
const mechanicalSketch = () => staticText("MechanicalSketch");
exports.mechanicalSketch = mechanicalSketch;
const pidDiagram = () => staticText("PidDiagram");
exports.pidDiagram = pidDiagram;
const pidDiagramEContact = () => staticText("pidDiagramEContact");
exports.pidDiagramEContact = pidDiagramEContact;
const systemSize = () => staticText("SystemSize");
exports.systemSize = systemSize;
const systemPrintout = () => staticText("SystemPrintout");
exports.systemPrintout = systemPrintout;
const systemDocuments = () => staticText("SystemDocuments");
exports.systemDocuments = systemDocuments;
const psychrometricsChart = () => staticText("PsychrometricsChart");
exports.psychrometricsChart = psychrometricsChart;
const adjustPrice = () => staticText("AdjustPrice");
exports.adjustPrice = adjustPrice;
const energy = () => staticText("Energy");
exports.energy = energy;
const mCompare = () => staticText("MCompare");
exports.mCompare = mCompare;
const totalCostOfOwnership = () => staticText("TotalCostOfOwnership");
exports.totalCostOfOwnership = totalCostOfOwnership;
const solidContactBuilder = () => staticText("SolidContactBuilder");
exports.solidContactBuilder = solidContactBuilder;
const wiringDiagramBuilder = () => staticText("wiringDiagramBuilder");
exports.wiringDiagramBuilder = wiringDiagramBuilder;
const revitBuilder = () => staticText("RevitBuilder");
exports.revitBuilder = revitBuilder;
const climatixControlFile = () => staticText("ClimatixControlFile");
exports.climatixControlFile = climatixControlFile;
const propertyGroup = () => staticText("PropertyGroup");
exports.propertyGroup = propertyGroup;
const properties = () => staticText("properties");
exports.properties = properties;
const systemAccessories = () => staticText("SystemAccessories");
exports.systemAccessories = systemAccessories;
const accessories = () => staticText("accessories");
exports.accessories = accessories;
const enhanceComponent = () => staticText("enhancecomponent");
exports.enhanceComponent = enhanceComponent;
const other = () => staticText("other");
exports.other = other;
const componentAlternatives = () => staticText("componentalternatives");
exports.componentAlternatives = componentAlternatives;
const notesAndDocuments = () => staticText("notesanddocuments");
exports.notesAndDocuments = notesAndDocuments;
const airLocations = () => staticText("airlocations");
exports.airLocations = airLocations;
const systemRevisionActions = () => staticText("systemrevisionactions");
exports.systemRevisionActions = systemRevisionActions;
const systemActions = () => staticText("systemactions");
exports.systemActions = systemActions;
const duplicate = () => staticText("duplicate");
exports.duplicate = duplicate;
const addNew = () => staticText("addnew");
exports.addNew = addNew;
const filters = () => staticText("filters");
exports.filters = filters;
const compare = () => staticText("compare");
exports.compare = compare;
const baselineSystem = () => staticText("baselinesystem");
exports.baselineSystem = baselineSystem;
const baseSystem = () => staticText("basesystem");
exports.baseSystem = baseSystem;
const baseline = () => staticText("baseline");
exports.baseline = baseline;
const alternative = () => staticText("alternative");
exports.alternative = alternative;
const noDescription = () => staticText("nodescription");
exports.noDescription = noDescription;
const immediatePayback = () => staticText("immediatepayback");
exports.immediatePayback = immediatePayback;
const noPayback = () => staticText("nopayback");
exports.noPayback = noPayback;
const tcoDeletedSystem = () => staticText("tcodeletedsystem");
exports.tcoDeletedSystem = tcoDeletedSystem;
const tcoNoSystemsFound = () => staticText("tconosystemsfound");
exports.tcoNoSystemsFound = tcoNoSystemsFound;
const maxcomparisonlimit = () => staticText("tco_maxcomparisonlimit");
exports.maxcomparisonlimit = maxcomparisonlimit;
const tcoSelectionsWarning = () => staticText("tcoselectionswarning");
exports.tcoSelectionsWarning = tcoSelectionsWarning;
const nrOFYearsInTheTco = () => staticText("nrofyearsinthetco");
exports.nrOFYearsInTheTco = nrOFYearsInTheTco;
const operatingScenario = () => staticText("operatingscenario");
exports.operatingScenario = operatingScenario;
const preferredResults = () => staticText("preferredresults");
exports.preferredResults = preferredResults;
const tcoAggregated = () => staticText("tcoAggregated");
exports.tcoAggregated = tcoAggregated;
const tcoYearOnYear = () => staticText("tcoYearOnYear");
exports.tcoYearOnYear = tcoYearOnYear;
const annualEnergyCost = () => staticText("annualEnergyCost");
exports.annualEnergyCost = annualEnergyCost;
const annualEnergyConsumption = () => staticText("annualEnergyConsumption");
exports.annualEnergyConsumption = annualEnergyConsumption;
const serviceCalculationFailed = () => staticText("serviceCalculationFailed");
exports.serviceCalculationFailed = serviceCalculationFailed;
const saveAndCalculate = () => staticText("saveandcalculate");
exports.saveAndCalculate = saveAndCalculate;
const calculateEnergyForThisSystem = () => staticText("calculateenergyforthissystem");
exports.calculateEnergyForThisSystem = calculateEnergyForThisSystem;
const systemIsLockedCantCalculateEnergy = () => staticText("systemislockedcantcalculateenergy");
exports.systemIsLockedCantCalculateEnergy = systemIsLockedCantCalculateEnergy;
const energyInput = () => staticText("energyinput");
exports.energyInput = energyInput;
const cost = () => staticText("cost");
exports.cost = cost;
const emissions = () => staticText("emissions");
exports.emissions = emissions;
const costAndEmissionsInformation = () => staticText("costAndEmissionsInformation");
exports.costAndEmissionsInformation = costAndEmissionsInformation;
const annualOperationInputs = () => staticText("annualOperationinputs");
exports.annualOperationInputs = annualOperationInputs;
const annualOperatingCases = () => staticText("annualoperatingcases");
exports.annualOperatingCases = annualOperatingCases;
const operationTime = () => staticText("operationTime");
exports.operationTime = operationTime;
const generateBinCases = () => staticText("generatebincases");
exports.generateBinCases = generateBinCases;
const calculateEnergyCompareForThisSystem = () => staticText("calculateenergycompareforthissystem");
exports.calculateEnergyCompareForThisSystem = calculateEnergyCompareForThisSystem;
const sortBy = () => staticText("sortBy");
exports.sortBy = sortBy;
const latest = () => staticText("latest");
exports.latest = latest;
const oldest = () => staticText("oldest");
exports.oldest = oldest;
const openInNewTab = () => staticText("openInNewTab");
exports.openInNewTab = openInNewTab;
const invalidBinMessage = () => staticText("invalidBinMessage");
exports.invalidBinMessage = invalidBinMessage;
const openInCurrentTab = () => staticText("openincurrenttab");
exports.openInCurrentTab = openInCurrentTab;
const copyOfSystemCompletedMsg = () => staticText("copyofsystemcompleted");
exports.copyOfSystemCompletedMsg = copyOfSystemCompletedMsg;
const revisionCompletedMsg = () => staticText("revisoncompleted");
exports.revisionCompletedMsg = revisionCompletedMsg;
const calculationfailed = () => staticText("calculationfailed");
exports.calculationfailed = calculationfailed;
const electricity = () => staticText("electricity");
exports.electricity = electricity;
const gasHeaters = () => staticText("gasheaters");
exports.gasHeaters = gasHeaters;
const chilledWaterSystem = () => staticText("chilledwatersystem");
exports.chilledWaterSystem = chilledWaterSystem;
const hotWaterSystem = () => staticText("hotWaterSystem");
exports.hotWaterSystem = hotWaterSystem;
const steamHeatSystem = () => staticText("steamHeatSystem");
exports.steamHeatSystem = steamHeatSystem;
const humidifier = () => staticText("humidifier");
exports.humidifier = humidifier;
const water = () => staticText("water");
exports.water = water;
const sewage = () => staticText("sewage");
exports.sewage = sewage;
const dhCapacityInfo = () => staticText("dhCapacityInfo");
exports.dhCapacityInfo = dhCapacityInfo;
const calculate = () => staticText("calculate");
exports.calculate = calculate;
const CustomPressure = () => staticText("custompressure");
exports.CustomPressure = CustomPressure;
const validateSelections = () => staticText("validateselections");
exports.validateSelections = validateSelections;
const calculateDesign = () => staticText("calculatedesign");
exports.calculateDesign = calculateDesign;
const validateDesign = () => staticText("validatedesign");
exports.validateDesign = validateDesign;
const calculateRatingCases = () => staticText("calculateratingcases");
exports.calculateRatingCases = calculateRatingCases;
const generateCasings = () => staticText("generatecasings");
exports.generateCasings = generateCasings;
const validateFinal = () => staticText("validatefinal");
exports.validateFinal = validateFinal;
const calculateSound = () => staticText("calculatesound");
exports.calculateSound = calculateSound;
const calculatePrice = () => staticText("calculateprice");
exports.calculatePrice = calculatePrice;
const calculateEnergy = () => staticText("calculateenergy");
exports.calculateEnergy = calculateEnergy;
const saveAndCalculateEnergy = () => staticText("saveandcalculateenergy");
exports.saveAndCalculateEnergy = saveAndCalculateEnergy;
const validateMcompare = () => staticText("validatemcompare");
exports.validateMcompare = validateMcompare;
const calculateMcompare = () => staticText("calculatemcompare");
exports.calculateMcompare = calculateMcompare;
const lockRevision = () => staticText("lockrevision");
exports.lockRevision = lockRevision;
const revisions = () => staticText("revisions");
exports.revisions = revisions;
const addToFavorites = () => staticText("addtofavorites");
exports.addToFavorites = addToFavorites;
const removeFromFavorites = () => staticText("removefromfavorites");
exports.removeFromFavorites = removeFromFavorites;
const calcstepAlreadyCompleted = () => staticText("calcstep_alreadycompleted");
exports.calcstepAlreadyCompleted = calcstepAlreadyCompleted;
const message = () => staticText("message");
exports.message = message;
const permissionDenied = () => staticText("permissiondenied");
exports.permissionDenied = permissionDenied;
const moreMessages = () => staticText("MoreMessages");
exports.moreMessages = moreMessages;
const saveChangesQuestion = () => staticText("savechangesquestion");
exports.saveChangesQuestion = saveChangesQuestion;
const saveChangesToQuestion = (displayName) => staticTextWithParams("savechangestoquestion", displayName);
exports.saveChangesToQuestion = saveChangesToQuestion;
const addComponent = () => staticText("addcomponent");
exports.addComponent = addComponent;
const systemInputs = () => staticText("systeminputs");
exports.systemInputs = systemInputs;
const engineeringOutputs = () => staticText("engineeringoutputs");
exports.engineeringOutputs = engineeringOutputs;
const partsAndAccessories = () => staticText("partsandaccessories");
exports.partsAndAccessories = partsAndAccessories;
const operatingCaseName = (caseName) => staticText(caseName);
exports.operatingCaseName = operatingCaseName;
const move = () => staticText("move");
exports.move = move;
const exchangeComponent = () => staticText("exchangeComponent");
exports.exchangeComponent = exchangeComponent;
const cannotExchangeComponent = () => staticText("cannotexchangecomponentmsg");
exports.cannotExchangeComponent = cannotExchangeComponent;
const systemMessages = () => staticText("SystemMessages");
exports.systemMessages = systemMessages;
const revisionLockedMsg = () => staticText("revisionlockedmsg");
exports.revisionLockedMsg = revisionLockedMsg;
const locked = () => staticText("locked");
exports.locked = locked;
const currencyHasBeenChanged = () => staticText("currencyhasbeenchanged");
exports.currencyHasBeenChanged = currencyHasBeenChanged;
const diagram = () => staticText("diagram");
exports.diagram = diagram;
const mechanicalView = () => staticText("mechanicalview");
exports.mechanicalView = mechanicalView;
const notImplemented = () => staticText("notImplemented");
exports.notImplemented = notImplemented;
const components = () => staticText("components");
exports.components = components;
const casings = () => staticText("casings");
exports.casings = casings;
const systemName = () => staticText("systemname");
exports.systemName = systemName;
const preparedFor = () => staticText("preparedfor");
exports.preparedFor = preparedFor;
const salesOrder = () => staticText("salesorder");
exports.salesOrder = salesOrder;
const endUser = () => staticText("enduser");
exports.endUser = endUser;
const selection = () => staticText("selection");
exports.selection = selection;
const salesOrganisation = () => staticText("salesorganisation");
exports.salesOrganisation = salesOrganisation;
const quantityShort = () => staticText("quantityShort");
exports.quantityShort = quantityShort;
const partPrice = () => staticText("partprice");
exports.partPrice = partPrice;
const validTime = () => staticText("validtime");
exports.validTime = validTime;
const systemCalculationIsValidUntil = () => staticText("systemcalculationisvaliduntil");
exports.systemCalculationIsValidUntil = systemCalculationIsValidUntil;
const systemCalculation = () => staticText("systemcalculation");
exports.systemCalculation = systemCalculation;
const baseComponents = () => staticText("basecomponents");
exports.baseComponents = baseComponents;
const validityWarning = () => staticText("ValidityWarning");
exports.validityWarning = validityWarning;
const extendedInformation = () => staticText("extendedInformation");
exports.extendedInformation = extendedInformation;
const marginCost = () => staticText("margincost");
exports.marginCost = marginCost;
const masterMarginCost = () => staticText("mastermargincost");
exports.masterMarginCost = masterMarginCost;
const margin = () => staticText("margin");
exports.margin = margin;
const refCost = () => staticText("refcost");
exports.refCost = refCost;
const consolidatedMargin = () => staticText("consolidatedmargin");
exports.consolidatedMargin = consolidatedMargin;
const mczFactoryPrice = () => staticText("mczfactoryprice");
exports.mczFactoryPrice = mczFactoryPrice;
const transferPrice = () => staticText("transferprice");
exports.transferPrice = transferPrice;
const masterTransferPrice = () => staticText("mastertransferprice");
exports.masterTransferPrice = masterTransferPrice;
const oemPrice = () => staticText("oemprice");
exports.oemPrice = oemPrice;
const listPrice = () => staticText("listprice");
exports.listPrice = listPrice;
const masterListPrice = () => staticText("masterlistprice");
exports.masterListPrice = masterListPrice;
const productText = () => staticText("product");
exports.productText = productText;
const masterCurrency = () => staticText("mastercurrency");
exports.masterCurrency = masterCurrency;
const masterSalesOrganisation = () => staticText("masterSalesOrganisation");
exports.masterSalesOrganisation = masterSalesOrganisation;
const mCompareSystem = () => staticText("mcomparesystem");
exports.mCompareSystem = mCompareSystem;
const isInPricings = () => staticText("isinpricings");
exports.isInPricings = isInPricings;
const systemNotLocked = () => staticText("systemnotlocked");
exports.systemNotLocked = systemNotLocked;
const systemNotLockedShort = () => staticText("systemnotlockedshort");
exports.systemNotLockedShort = systemNotLockedShort;
const systemExpiredRecalculate = () => staticText("systemexpiredrecalculate");
exports.systemExpiredRecalculate = systemExpiredRecalculate;
const systemValidityExpired = () => staticText("systemvalidityexpired");
exports.systemValidityExpired = systemValidityExpired;
const calculatingEnergy = () => staticText("calculatingenergy");
exports.calculatingEnergy = calculatingEnergy;
const showResultFor = () => staticText("showresultfor");
exports.showResultFor = showResultFor;
const noPerformanceAvailable = () => staticText("noperformanceavailable");
exports.noPerformanceAvailable = noPerformanceAvailable;
const resultsSummary = () => staticText("resultssummary");
exports.resultsSummary = resultsSummary;
const opCaseResults = () => staticText("opcaseresults");
exports.opCaseResults = opCaseResults;
const calculateToShowDiagram = () => staticText("calculatetoshowdiagram");
exports.calculateToShowDiagram = calculateToShowDiagram;
const componentCalculationType = (type) => staticText(type
    .toLowerCase()
    .replace(/([a-z]+)_?/g, (_, g1) => g1[0].toUpperCase() + g1.substr(1)));
exports.componentCalculationType = componentCalculationType;
const cannotDeleteComponent = () => staticText("cannotdeletecomponentmsg");
exports.cannotDeleteComponent = cannotDeleteComponent;
const deleteComponent = () => staticText("deletecomponentmsg");
exports.deleteComponent = deleteComponent;
const internalNotes = () => staticText("internalnotes");
exports.internalNotes = internalNotes;
const externalNotes = () => staticText("externalnotes");
exports.externalNotes = externalNotes;
const documents = () => staticText("documents");
exports.documents = documents;
const mlcBuilding = () => staticText("mlcbuilding");
exports.mlcBuilding = mlcBuilding;
const mlcUsageStatistics = () => staticText("mlcusagestatistics");
exports.mlcUsageStatistics = mlcUsageStatistics;
const mlcOutdoorsClimate = () => staticText("mlcoutdoorclimate");
exports.mlcOutdoorsClimate = mlcOutdoorsClimate;
const mclOutOfDate = () => staticText("mlcoutofdate");
exports.mclOutOfDate = mclOutOfDate;
const mclUpdateDefinitions = () => staticText("mlcupdatedefinitions");
exports.mclUpdateDefinitions = mclUpdateDefinitions;
const mlcDesiredIndoorsClimate = () => staticText("mlcdesiredindoorsclimate");
exports.mlcDesiredIndoorsClimate = mlcDesiredIndoorsClimate;
const mlcSystem = () => staticText("mlcsystem");
exports.mlcSystem = mlcSystem;
const mlcSystemAndBuildingConfig = () => staticText("mlcsystemandbuildingconfig");
exports.mlcSystemAndBuildingConfig = mlcSystemAndBuildingConfig;
const mlcSystemOperationtime = () => staticText("mlcsystemoperationtime");
exports.mlcSystemOperationtime = mlcSystemOperationtime;
const mlcBuildingExtended = () => staticText("mlcbuildingextended");
exports.mlcBuildingExtended = mlcBuildingExtended;
const mlcApplicationTypeInfo = () => staticText("mlcapplicationtypeinfo");
exports.mlcApplicationTypeInfo = mlcApplicationTypeInfo;
const mlcApplicationType = () => staticText("mlcapplicationtype");
exports.mlcApplicationType = mlcApplicationType;
const mlcNoTargethum = () => staticText("mlcnotargethum");
exports.mlcNoTargethum = mlcNoTargethum;
const mlcNoTargetTemp = () => staticText("mlcnotargettemp");
exports.mlcNoTargetTemp = mlcNoTargetTemp;
const mlcApplicationTypes = (type) => staticText("mlcapplicationtype_" + type);
exports.mlcApplicationTypes = mlcApplicationTypes;
const mlcSystemConfiguration = () => staticText("mlcsystemconfiguration");
exports.mlcSystemConfiguration = mlcSystemConfiguration;
const mlcHasToBeLocked = () => staticText("mlchastobelocked");
exports.mlcHasToBeLocked = mlcHasToBeLocked;
const mlcEmptyLoadTypeName = () => staticText("mlcEmptyLoadTypeName");
exports.mlcEmptyLoadTypeName = mlcEmptyLoadTypeName;
const mlcDuplicatedLoadTypeName = () => staticText("mlcDuplicatedLoadTypeName");
exports.mlcDuplicatedLoadTypeName = mlcDuplicatedLoadTypeName;
const mlcLoadOperationTimeHasNoHours = () => staticText("mlcLoadOperationTimeHasNoHours");
exports.mlcLoadOperationTimeHasNoHours = mlcLoadOperationTimeHasNoHours;
const mlcLoadOperationTimeOutsideSystemOperationTime = () => staticText("mlcLoadOperationTimeOutsideSystemOperationTime");
exports.mlcLoadOperationTimeOutsideSystemOperationTime = mlcLoadOperationTimeOutsideSystemOperationTime;
const mlcSystemOperationTimeHasNoHours = () => staticText("mlcSystemOperationTimeHasNoHours");
exports.mlcSystemOperationTimeHasNoHours = mlcSystemOperationTimeHasNoHours;
const mlcManualClimateBinsIncomplete = () => staticText("mlcManualClimateBinsIncomplete");
exports.mlcManualClimateBinsIncomplete = mlcManualClimateBinsIncomplete;
const mlcSystemConfigurationTypes = (type) => staticText("mlcsystemconfiguration_" + type);
exports.mlcSystemConfigurationTypes = mlcSystemConfigurationTypes;
const mlcSystemOperationTime = () => staticText("mlcsystemoperationtime");
exports.mlcSystemOperationTime = mlcSystemOperationTime;
const mlcNoSystemsconnected = () => staticText("mlcnosystemsconnected");
exports.mlcNoSystemsconnected = mlcNoSystemsconnected;
const mlcAddMoistureAndHeaTypes = () => staticText("mlcaddmoistureandheattypes");
exports.mlcAddMoistureAndHeaTypes = mlcAddMoistureAndHeaTypes;
const mlOnoeOrMoreMissingLoadsRequired = () => staticText("mlconeormoremissingloadsrequired");
exports.mlOnoeOrMoreMissingLoadsRequired = mlOnoeOrMoreMissingLoadsRequired;
const mlcNoLabelsAssigned = () => staticText("mlcnolabelsassigned");
exports.mlcNoLabelsAssigned = mlcNoLabelsAssigned;
const mlcLoadsWithMoisture = () => staticText("mlcloadswithmoisture");
exports.mlcLoadsWithMoisture = mlcLoadsWithMoisture;
const mlcMinTargetTemp = () => staticText("mlcmintargettemp");
exports.mlcMinTargetTemp = mlcMinTargetTemp;
const mlcMaxTargetTemp = () => staticText("mlcmaxtargettemp");
exports.mlcMaxTargetTemp = mlcMaxTargetTemp;
const mlcConstantTargetTemp = () => staticText("mlcconstanttargettemp");
exports.mlcConstantTargetTemp = mlcConstantTargetTemp;
const mlcLoadsWithHeat = () => staticText("mlcloadswithheat");
exports.mlcLoadsWithHeat = mlcLoadsWithHeat;
const mlcLoadsWithBoth = () => staticText("mlcloadswithboth");
exports.mlcLoadsWithBoth = mlcLoadsWithBoth;
const mlcCreateWithSysSel = () => staticText("mlcCreateWithSysSel");
exports.mlcCreateWithSysSel = mlcCreateWithSysSel;
const mlcCreateSystemFromopc = () => staticText("mlccreatesystemfromopc");
exports.mlcCreateSystemFromopc = mlcCreateSystemFromopc;
const mlcBinDataLocation = () => staticText("mlcbindatalocation");
exports.mlcBinDataLocation = mlcBinDataLocation;
const mlclatestRevNeedsToBeLocked = () => staticText("mlclatestrevneedstobelocked");
exports.mlclatestRevNeedsToBeLocked = mlclatestRevNeedsToBeLocked;
const mlcCreateNewRevision = () => staticText("mlccreatenewrevision");
exports.mlcCreateNewRevision = mlcCreateNewRevision;
const mlcAssginLabels = () => staticText("mlcassignLabels");
exports.mlcAssginLabels = mlcAssginLabels;
const mlcDelete = () => staticText("mlcdelete");
exports.mlcDelete = mlcDelete;
const mlcCopyLatestRevision = () => staticText("mlccopylatestrevision");
exports.mlcCopyLatestRevision = mlcCopyLatestRevision;
const mlcTransferToUser = () => staticText("mlctransfertouser");
exports.mlcTransferToUser = mlcTransferToUser;
const mlcRename = () => staticText("mlcrename");
exports.mlcRename = mlcRename;
const mlcAccesControl = () => staticText("mlcaccesscontrol");
exports.mlcAccesControl = mlcAccesControl;
const mlcOk = () => staticText("mlcok");
exports.mlcOk = mlcOk;
const mlcviewAs = () => staticText("mlcviewas");
exports.mlcviewAs = mlcviewAs;
const mlcReportoptions = () => staticText("mlcreportOptions");
exports.mlcReportoptions = mlcReportoptions;
const mlcHeaderLabel = () => staticText("mlcheaderlabel");
exports.mlcHeaderLabel = mlcHeaderLabel;
const mlcPapersize = () => staticText("mlcpapersize");
exports.mlcPapersize = mlcPapersize;
const mlcLanguage = () => staticText("mlclanguage");
exports.mlcLanguage = mlcLanguage;
const mlcHasNotBeenCalculatedError = () => staticText("mlchasnotbeenbalculatederror");
exports.mlcHasNotBeenCalculatedError = mlcHasNotBeenCalculatedError;
const mlcMoistureHeatLoadTypes = () => staticText("mlcmoistureheatloadtypes");
exports.mlcMoistureHeatLoadTypes = mlcMoistureHeatLoadTypes;
const mlcSelectDeselectHeatLoads = () => staticText("mlcselectdeselectheatloads");
exports.mlcSelectDeselectHeatLoads = mlcSelectDeselectHeatLoads;
const mlcSelectDeselectMoistureLoads = () => staticText("mlcselectdeselectmoistureloads");
exports.mlcSelectDeselectMoistureLoads = mlcSelectDeselectMoistureLoads;
const newVersionMessage = () => staticText("newversionmessage");
exports.newVersionMessage = newVersionMessage;
const cannotAddProduct = (productId) => curlyTranslate(`{product} "{${productId}}" {cannotaddproduct}`, productId.substring(0, 3));
exports.cannotAddProduct = cannotAddProduct;
const perfParam = (pp) => staticText("pp_" + pp);
exports.perfParam = perfParam;
const specProp = (sp, systemTypeId) => staticText("s_" + systemTypeId + "_" + sp, systemTypeId);
exports.specProp = specProp;
const shouldBeBetweenMinMax = (min, max) => staticTextWithParams("ShouldBebetweenminmax", min, max);
exports.shouldBeBetweenMinMax = shouldBeBetweenMinMax;
const shouldBeEquals = (left, right) => staticTextWithParams("ShouldBeEquals", left, right);
exports.shouldBeEquals = shouldBeEquals;
const shouldBeNotEquals = (left, right) => staticTextWithParams("ShouldBeNotEquals", left, right);
exports.shouldBeNotEquals = shouldBeNotEquals;
const shouldBeGreater = (left, right) => staticTextWithParams("ShouldBeGreater", left, right);
exports.shouldBeGreater = shouldBeGreater;
const shouldBeGreaterOrEqual = (left, right) => staticTextWithParams("ShouldBeGreaterOrEqual", left, right);
exports.shouldBeGreaterOrEqual = shouldBeGreaterOrEqual;
const shouldBeLess = (left, right) => staticTextWithParams("ShouldBeLess", left, right);
exports.shouldBeLess = shouldBeLess;
const shouldBeLessOrEqual = (left, right) => staticTextWithParams("ShouldBeLessOrEqual", left, right);
exports.shouldBeLessOrEqual = shouldBeLessOrEqual;
const filterOptionsText = (propertyName) => {
    if (propertyName === "pno") {
        return staticText("pricingNO");
    }
    return staticText(propertyName);
};
exports.filterOptionsText = filterOptionsText;
const deleteAllSelectedMsg = (systems) => staticTextWithParams("deleteallselectedmsg", systems.toString());
exports.deleteAllSelectedMsg = deleteAllSelectedMsg;
const globalPropertyName = (propertyName) => staticText(propertyName);
exports.globalPropertyName = globalPropertyName;
const globalPropertyDescription = (propertyName) => staticText(`${propertyName}_description`);
exports.globalPropertyDescription = globalPropertyDescription;
const dynamicText = (text, systemTypeId) => staticText(text, systemTypeId);
exports.dynamicText = dynamicText;
const errorMessage = (message) => staticText(message);
exports.errorMessage = errorMessage;
const pricingArticle = (articleName) => staticText("article_" + articleName);
exports.pricingArticle = pricingArticle;
const processingToolTip = (mode) => staticText("calcstep_" + mode);
exports.processingToolTip = processingToolTip;
const fileFormat = (fileFormat) => staticText("fileformat_" + fileFormat);
exports.fileFormat = fileFormat;
const calculationProgress = (state) => staticText("calculationprogress_" + state);
exports.calculationProgress = calculationProgress;
function languageId(id) {
    return {
        type: "LanguageIdText",
        languageId: id
    };
}
const functionType = (functionTypeTextId) => staticText(functionTypeTextId);
exports.functionType = functionType;
function product(productId) {
    return {
        type: "ProductText",
        productId
    };
}
function systemTypeProperty(systemTypeId, propertyName) {
    return {
        type: "SystemTypePropertyText",
        systemTypeId,
        propertyName
    };
}
function systemTypePropertyValue(systemTypeId, propertyName, propertyValue) {
    return {
        type: "SystemTypePropertyValueText",
        systemTypeId,
        propertyName,
        propertyValue
    };
}
function productProperty(productId, propertyName) {
    return {
        type: "ProductPropertyText",
        productId,
        propertyName
    };
}
function productPropertyValue(productId, propertyName, propertyValue) {
    return {
        type: "ProductPropertyValueText",
        productId,
        propertyName,
        propertyValue
    };
}
function reportParam(paramName, systemTypeId) {
    return {
        type: "ReportParamText",
        paramName,
        systemTypeId
    };
}
function reportParamValue(paramName, paramValue, systemTypeId) {
    return {
        type: "ReportParamValueText",
        paramName,
        paramValue,
        systemTypeId
    };
}
function systemTypeIdText(systemId) {
    return {
        type: "SystemIdText",
        systemId
    };
}
function tabTitleText(key) {
    return {
        type: "TabTitleText",
        key
    };
}
function createTranslateTodoText(textId) {
    return {
        type: "TranslateTodoText",
        textId
    };
}
function curlyTranslate(text, systemTypeId) {
    return {
        type: "CurlyText",
        text,
        systemTypeId
    };
}
function staticText(textId, systemTypeId) {
    return {
        type: "StaticText",
        textId,
        systemTypeId
    };
}
function staticTextWithParams(textId, ...parameters) {
    return {
        type: "StaticTextWithParameters",
        textId,
        parameters
    };
}
//# sourceMappingURL=text-definitions.js.map